module.exports = __webpack_public_path__ + "static/media/hand-scissors.95800f1d.svg";